import PropTypes from "prop-types"
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useContext,
  useRef,
} from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Badge,
  Modal,
  Button,
} from "reactstrap"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import {
  DeleteSegmentation,
  SearchSegmentation,
  ExportSegmentationById,
  ReloadSegmentationById,
} from "../../services/Api/Module/Segmentation"
import Spinners from "components/Common/Spinner"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainerAPI from "../../components/Common/TableContainerAPI"
import { withTranslation } from "react-i18next"

import moment from "moment"
import Pagination from "components/Common/Pagination"
import InputWait from "components/Common/InputWait"
import ModalContext from "contexts/ModalContext"
import helper from "services/helper"
// import { checkScope } from "helpers/utility_helper";

import { ExportToExcel } from "../../helpers/Export/excel"

const RowStatus = ({ status }) => {
  switch (status) {
    case "inactive":
      return <Badge className="bg-warning"> Inactive </Badge>

    case "deleted":
      return <Badge className="bg-danger"> Deleted </Badge>

    case "active":
      return <Badge className="bg-success"> Active </Badge>

    default:
      return <Badge className="bg-success"> {status} </Badge>
  }
}
const DEF_LIMIT = 10
const DEF_OFFSET = 0

const SegmentationList = props => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  const navigate = useNavigate()
  let [searchParams, setSearchParams] = useSearchParams()

  // Main DATA
  const limit = DEF_LIMIT
  const offset = searchParams.get("offset") ?? DEF_OFFSET
  const sortField = searchParams.get("sortField") ?? "createdOn"
  const sortOrder = searchParams.get("sortOrder") ?? "desc"
  const [rowCount, setRowCount] = useState()
  const [segmentationList, setSegmentationList] = useState([])
  const [selectedIds, setSelectedIds] = useState([])

  const [segmentName, setSegmentName] = useState("")
  const isFirstSegmentNameEffect = useRef(true)
  const [isLoading, setIsLoading] = useState(false)

  const getTempParams = () => ({
    offset: searchParams.get("offset") ?? DEF_OFFSET,
    sortField: searchParams.get("sortField") ?? "createdOn",
    sortOrder: searchParams.get("sortOrder") ?? "desc",
  })

  const onSort = event => {
    console.log("🚀 ~ onSort ~ event:", event)
    const { sortField, sortOrder } = event
    setSearchParams({ ...getTempParams(), sortField, sortOrder: sortOrder })
  }

  const onSelectionChange = (
    selectedValue = {},
    oldValues = [],
    option = [],
    mode = ""
  ) => {
    const selectedId = selectedValue?.id
    const tmpOldValues = _.cloneDeep(oldValues)
    const findOldValue = tmpOldValues.filter(id => id === selectedId)

    let updateState = []
    if (findOldValue && findOldValue.length) {
      updateState = tmpOldValues.filter(id => id != selectedId)
    } else {
      updateState = tmpOldValues
      updateState.push(selectedId)
    }

    if (mode === "all") {
      if (tmpOldValues.length >= option.length) {
        updateState = []
      } else {
        updateState = option.map(item => item.id)
      }
    }
    console.log("🚀 ~ onChangeEnum ~ updateState:", updateState)
    setSelectedIds(updateState)
  }

  const fetchSearchSegmentation = async payload => {
    try {
      const response = await SearchSegmentation({ params: payload })
      const resData = response.data
      // const resData = await getCustomerProfile()
      setIsLoading(false)
      if (resData.resultCode === 20000) {
        // console.log("resData.resultData >>", resData.resultData)
        setSegmentationList(resData.resultData)
        setRowCount(parseInt(resData?.rowCount || 0))
      }
    } catch (err) {
      console.log("err ", err)
      setIsLoading(false)
    }
  }

  const fetchDeleteSegmentation = async payload => {
    try {
      const response = await DeleteSegmentation({ data: payload })
      const resData = response.data
      // const resData = await getCustomerProfile()
      if (resData.resultCode === 20203) {
        mAlert.info({
          title: "Alert",
          subTitle: "Delete Data Success",
          content: "",
          onClose: () => {
            fetchAPI()
            setSearchParams({ ...getTempParams(), offset: 0 })
          },
        })
      }
    } catch (err) {
      console.log("err ", err)
      mAlert.info({
        title: "Alert",
        subTitle: "Something went wrong",
        content: "",
        onClose: () => {
          //  alert("onClose")
        },
      })
    }
  }

  const fetchAPI = () => {
    const currentOffset = searchParams.get("offset") ?? DEF_OFFSET
    const currentSortField = searchParams.get("sortField") ?? "createdOn"
    const currentSortOrder = searchParams.get("sortOrder") ?? "desc"
    
    const payload = {
      segmentName: segmentName,
      sortBy: `${currentSortField}|${currentSortOrder}`,
      offset: currentOffset,
      limit: limit,
    }
    setIsLoading(true)
    fetchSearchSegmentation(payload)
  }

  useEffect(() => {
    if (isFirstSegmentNameEffect.current) {
      isFirstSegmentNameEffect.current = false
      return
    }

    // Reset offset to 0 when segmentName changes
    const currentParams = getTempParams()
    setSearchParams({ ...currentParams, offset: 0 })
    
    // Fetch API immediately with reset offset
    const currentSortField = searchParams.get("sortField") ?? "createdOn"
    const currentSortOrder = searchParams.get("sortOrder") ?? "desc"
    const payload = {
      segmentName: segmentName,
      sortBy: `${currentSortField}|${currentSortOrder}`,
      offset: 0,
      limit: limit,
    }
    setIsLoading(true)
    fetchSearchSegmentation(payload)
  }, [segmentName])

  useEffect(() => {
    fetchAPI()
  }, [sortField, sortOrder, offset])

  const onDeleteRow = (ids = [], name = "") => {
    mAlert.info({
      type: "confrim",
      title: "Alert Confrim",
      subTitle: `Are you sure Delete ${name} ?`,
      mode: "red",
      content: "",
      onClose: () => {},
      onYes: () => {
        const payload = { segmentationId: ids }
        fetchDeleteSegmentation(payload)
      },
      onNo: () => {
        console.log("Cancel")
      },
    })
  }

  const onSelectAll = (_selectedIds = [], _tableList = []) => {
    const oldSelectedIds = _.cloneDeep(_selectedIds)
    const allIds = _tableList.map(item => item.id)

    if (_.isEmpty(_.difference(allIds, oldSelectedIds))) {
      // console.log('onSelectAll AAA')
      // console.log('onSelectAll AAA oldSelectedIds', oldSelectedIds)
      // console.log('onSelectAll AAA allIds', allIds)
      const newSelectIds = oldSelectedIds.filter(item => !allIds.includes(item))
      setSelectedIds(newSelectIds)
    } else {
      // console.log('onSelectAll BBB')
      // console.log('onSelectAll BBB oldSelectedIds', oldSelectedIds)
      // console.log('onSelectAll BBB allIds', allIds)
      const newSelectIds = [...new Set([...allIds, ...oldSelectedIds])]
      setSelectedIds(newSelectIds)
    }
  }

  const updateCellData = (rowIndex, columnId, value) => {
    setSegmentationList(oldData =>
      oldData.map((row, index) =>
        index === rowIndex ? { ...row, [columnId]: value } : row
      )
    )
  }

  const columns = useMemo(() => {
    const formatDate = (txtDate = "") => {
      if (txtDate) {
        return moment(txtDate).add("h", 7).format("DD/MM/YYYY HH:mm")
      }
      return "-"
    }
    return [
      {
        id: "colcheckbox",
        header: () => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => onSelectAll(selectedIds, segmentationList)}
            >
              <Input
                type={`checkbox`}
                checked={selectedIds.length === rowCount && rowCount > 0}
                style={{ margin: "0px", marginBottom: "4px" }}
                readOnly
              />
            </div>
          )
        },
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: cellProps => {
          const item = { ...cellProps.row.original }
          return (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={e =>
                  onSelectionChange(
                    item,
                    _.cloneDeep(selectedIds),
                    _.cloneDeep(segmentationList)
                  )
                }
              >
                <Input
                  type={`checkbox`}
                  checked={selectedIds.includes(item.id)}
                  readOnly
                />
              </div>
            </>
          )
        },
      },
      // {
      //     header: 'id',
      //     enableColumnFilter: false,
      //     enableSorting: true,
      //     cell: (cellProps) => {
      //         return (
      //             <>
      //                 <div style={{ display: "flex", justifyContent: "center" }}>
      //                     { cellProps.row.original.id }
      //                 </div>
      //             </>
      //         )
      //     }
      // },
      {
        header: "Segment Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Total Member",
        accessorKey: "totalMember",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps, value) => (
          <div>
            {cellProps.row.original.totalMember
              ? helper.FN.toNumberWithCommas(cellProps.row.original.totalMember)
              : 0}
          </div>
        ),
        // cell: (cellProps, value) => {
        //   // console.log("cellProps >>>", cellProps)

        //   const { totalMember } = cellProps.row.original
        //   const [_totalMember, _setTotalMember] = useState(totalMember)

        //   const onBlur = () => {
        //     console.log(cellProps.row.index, cellProps.column.id, _totalMember)

        //     updateCellData(
        //       cellProps.row.index,
        //       cellProps.column.id,
        //       _totalMember
        //     )
        //   }

        //   return (
        //     <>
        //       <input
        //         value={helper.FN.toNumberWithCommas(totalMember || 0)}
        //         onChange={e => _setTotalMember(e.target.value)}
        //         onBlur={onBlur}
        //         className="border"
        //         readOnly
        //       />
        //     </>
        //   )
        // },
      },
      {
        header: "Created On",
        accessorKey: "createdOn",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps, value) => (
          <div>{formatDate(cellProps.row.original.createdOn)}</div>
        ),
      },
      {
        header: "Updated On",
        accessorKey: "updatedOn",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => (
          <div>{formatDate(cellProps.row.original.updatedOn)}</div>
        ),
      },
      // {
      //     header: 'User Status',
      //     accessorKey: 'user_status',
      //     enableColumnFilter: false,
      //     enableSorting: true,
      //     cell: (cellProps) => <RowStatus status={cellProps.row.original.user_status} />
      // },
      {
        header: "Action",
        accessorKey: "user_id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: cellProps => {
          const { id, name, broadcastCount, broadcastSendCount } =
            cellProps.row.original

          const [isExcelLoading, setIsExcelLoading] = useState(null)

          const fetchExportSegmentationById = async payload => {
            setIsExcelLoading(payload.segmentId)

            let _return = {
              status: false,
              result: null,
            }

            try {
              const response = await ExportSegmentationById({
                id: payload.segmentId,
              })
              const resData = response.data
              if (resData.resultCode === 20000) {
                // console.log("resData.resultData >>", resData.resultData)

                _return.status = true
                _return.result = resData.resultData
              } else {
                console.log("resData", resData)
              }

              setIsExcelLoading(null)
            } catch (err) {
              console.warn("err ", err)
            }

            return _return
          }

          const handleExportSegmentationById = (_segmentId, _segmentName) => {
            // console.log("handleExportSegmentationById >>>", "_segmentId", _segmentId)

            fetchExportSegmentationById({
              segmentId: _segmentId,
            }).then(_rsData => {
              ExportToExcel(_rsData.result || [], `Segment ${_segmentName}`)
            })
          }

          const [isReloadLoading, setIsReloadLoading] = useState(null)

          const fetchReloadSegmentationById = async payload => {
            setIsReloadLoading(payload.segmentId)

            let _return = {
              status: false,
              result: null,
            }

            try {
              const response = await ReloadSegmentationById({
                id: payload.segmentId,
              })
              const resData = response.data
              if (resData.resultCode === 20000) {
                // console.log("resData.resultData >>", resData.resultData)

                _return.status = true
                _return.result = resData.resultData
              } else {
                console.log("resData", resData)
              }

              setIsReloadLoading(null)
            } catch (err) {
              console.warn("err ", err)
            }

            return _return
          }

          const handleReloadSegmentationById = _segmentId => {
            // console.log(
            //   "handleReloadSegmentationById >>>",
            //   "_segmentId",
            //   _segmentId
            // )

            fetchReloadSegmentationById({
              segmentId: _segmentId,
            }).then(_rsData => {
              // console.log("_rsData >>>", _rsData)

              updateCellData(
                cellProps.row.index,
                "totalMember",
                _rsData.result?.totalMember || 0
              )
            })
          }

          return (
            <div className="d-flex gap-1">
              <Button
                color="success"
                onClick={() => handleExportSegmentationById(id, name)}
                disabled={isExcelLoading === id}
              >
                <small>
                  {`Export (.xlsx) `}
                  {isExcelLoading === id ? (
                    <i className="bx bx-loader bx-spin"></i>
                  ) : (
                    <i className="bx bx-download"></i>
                  )}
                </small>
              </Button>
              {broadcastSendCount == 0 ? (
                <>
                  <Button
                    color="primary"
                    onClick={() => handleReloadSegmentationById(id)}
                    disabled={isReloadLoading === id}
                  >
                    <small>
                      {`Reload `}
                      {isReloadLoading === id ? (
                        <i className="bx bx-loader bx-spin"></i>
                      ) : (
                        <i className="bx bx-revision"></i>
                      )}
                    </small>
                  </Button>
                  <Link
                    className={`btn btn-warning`}
                    to={`/segmentation-edit/${id}`}
                  >
                    <i className={`bx bx-edit-alt`}></i>
                  </Link>
                </>
              ) : (
                <Link
                  className={`btn btn-info`}
                  to={`/segmentation-view/${id}`}
                >
                  <i className={`bx bx-show-alt`}></i>
                </Link>
              )}
              {broadcastCount == 0 && (
                <div
                  className={`btn btn-danger`}
                  onClick={() => onDeleteRow([id], name)}
                >
                  <i className={`bx bx-basket`}></i>
                </div>
              )}
            </div>
          )
        },
      },
    ]
  }, [selectedIds, segmentationList])

  //meta title
  document.title = "Segmentation List"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Segmentation" breadcrumbItem="Segmentation" />
        {isLoading && false ? (
          <Spinners setLoading={v => setIsLoading(v)} />
        ) : (
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center mb-3">
                    <h5 className="mb-0 card-title">Segmentation Lists</h5>
                  </div>
                  <div className="d-flex ">
                    <div className="d-flex align-items-center flex-grow-1">
                      <InputWait
                        value={segmentName ?? ""}
                        onChange={value => setSegmentName(String(value))}
                        className="form-control search-box me-2 mb-2 d-inline-block"
                        placeholder={"Search Segment Name"}
                      />
                    </div>
                    <div className="flex-shrink-0">
                      <Link to="/segmentation-add" className="btn btn-primary">
                        <i className="bx bx-plus align-middle"></i> Add
                        Segmentation
                      </Link>
                    </div>
                  </div>
                  <div className="d-flex " style={{ minHeight: 36.5 }}>
                    <div className="d-flex align-items-center flex-grow-1"></div>
                    {selectedIds.length > 0 && (
                      <div className="flex-shrink-0 d-flex gap-2">
                        <a
                          className="btn btn-info"
                          onClick={() => setSelectedIds([])}
                        >
                          {" "}
                          Clear Selected All
                        </a>
                        <a
                          className="btn btn-danger"
                          onClick={() => onDeleteRow(_.cloneDeep(selectedIds))}
                        >
                          {" "}
                          Delele Selected
                        </a>
                      </div>
                    )}
                  </div>
                </CardBody>
                <CardBody>
                  <TableContainerAPI
                    SearchPlaceholder="Search"
                    columns={columns}
                    data={segmentationList || []}
                    onSort={onSort}
                    sortField={sortField}
                    sortOrder={sortOrder}
                    isAddButton={true}
                    addRowLink={`/useradd`}
                    isExportButton={true}
                    exportLink={`/userexport`}
                    isGlobalFilter={true}
                    tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                  />

                  <Pagination
                    limit={limit}
                    offset={offset}
                    rowCount={rowCount}
                    onBack={(limit, offset) => {
                      setSearchParams({ ...getTempParams(), offset })
                    }}
                    onNext={(limit, offset) => {
                      setSearchParams({ ...getTempParams(), offset })
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {/* {segmentName} */}
      </div>
    </div>
  )
}

SegmentationList.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(SegmentationList)
